import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { Dialog } from "@material-ui/core";

import { DialogModalStyles } from "./commonStyles";

const DialogModalCommonComponent = props => (<Dialog {...props} />);

export default withStyles(DialogModalStyles)(DialogModalCommonComponent);
